var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLogo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2000px",
    height: "439px",
    viewBox: "0 0 2000 439",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo/full/color",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-3",
    transform: "translate(427.687113, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.350525,118.759492 C250.795214,118.759492 315.008482,187.227974 315.008482,278.721256 C315.008482,283.972526 314.739244,288.9545 314.38026,293.846709 L314.38026,293.846709 L313.796911,301.140139 C312.58534,310.834792 306.527484,315.076202 297.440701,315.076202 L297.440701,315.076202 L95.1446757,315.076202 C106.151798,351.07366 134.417753,365.367211 165.985238,365.367211 C182.947234,365.367211 199.909229,359.308053 210.813369,350.219317 L210.813369,350.219317 L212.010042,349.274447 C217.530857,344.981512 222.242522,342.342412 229.59272,342.342412 L229.59272,342.342412 L287.748132,341.736496 C298.652272,341.736496 304.710128,349.007485 299.863843,358.702138 L299.863843,358.702138 L298.754984,361.117046 C274.706896,412.249317 225.613175,438.68302 164.773667,438.68302 C64.2132674,438.68302 0,369.002706 0,278.721256 C0,188.439805 66.6364096,118.759492 162.350525,118.759492 Z M161.74473,199.346289 C127.687467,199.346289 104.122413,215.784787 94.7630279,246.001804 L94.7630279,246.001804 L224.55258,246.001804 C215.187132,211.5252 188.465931,199.346289 161.74473,199.346289 Z",
    id: "Combined-Shape",
    fill: "#010709",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M677.268236,118.759492 C640.921103,118.759492 615.690139,133.816502 596.056627,154.829657 C580.809006,131.132291 556.407966,118.765547 525.82185,118.765547 C494.17561,118.765547 470.041116,133.786195 456.156513,154.756941 L456.156513,142.396263 C456.156513,132.70161 450.704443,127.248368 441.011874,127.248368 L380.43332,127.248368 C370.740752,127.248368 365.288682,132.70161 365.288682,142.396263 L365.288682,415.05836 C365.288682,424.753013 370.740752,430.206255 380.43332,430.206255 L441.011874,430.206255 C450.704443,430.206255 456.156513,424.753013 456.156513,415.05836 L456.156513,241.160534 C456.156513,211.470661 473.118508,202.381924 491.292074,202.381924 C508.25407,202.381924 522.792923,209.652913 522.792923,233.889544 L522.792923,415.05836 C522.792923,424.753013 528.244992,430.206255 537.937561,430.206255 L598.516115,430.206255 C608.208684,430.206255 613.660754,424.753013 613.660754,415.05836 L613.660754,241.160534 C613.660754,211.470661 630.622749,202.381924 648.796315,202.381924 C665.75831,202.381924 680.297163,209.652913 680.297163,233.889544 L680.297163,415.05836 C680.297163,424.753013 685.749233,430.206255 695.441802,430.206255 L756.020356,430.206255 C765.712925,430.206255 771.164995,424.753013 771.164995,415.05836 L771.164995,226.012639 C771.164995,157.142561 737.433568,119.643535 679.329087,118.780777 L677.268236,118.759492 Z",
    id: "Path",
    fill: "#010709",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M845.070831,430.200199 L905.649385,430.200199 C915.341954,430.200199 920.794024,424.746957 920.794024,415.052305 L920.794024,142.390207 C920.794024,132.695554 915.341954,127.242312 905.649385,127.242312 L845.070831,127.242312 C835.378262,127.242312 829.926192,132.695554 829.926192,142.390207 L829.926192,415.052305 C829.926192,424.746957 835.378262,430.200199 845.070831,430.200199 Z",
    id: "Path",
    fill: "#010709",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1135.84789,127.242312 L1102.52969,127.242312 L1102.52969,45.443683 C1102.52969,35.7490306 1097.07762,30.2957887 1087.38505,30.2957887 L1026.80649,30.2957887 C1017.11392,30.2957887 1011.66185,35.7490306 1011.66185,45.443683 L1011.66185,127.242312 L978.34365,127.242312 C968.651081,127.242312 963.199011,132.695554 963.199011,142.390207 L963.199011,199.346289 C963.199011,209.040942 968.651081,214.494184 978.34365,214.494184 L1011.66185,214.494184 L1011.66185,415.052305 C1011.66185,424.746957 1017.11392,430.200199 1026.80649,430.200199 L1087.38505,430.200199 C1097.07762,430.200199 1102.52969,424.746957 1102.52969,415.052305 L1102.52969,214.494184 L1135.84789,214.494184 C1145.54046,214.494184 1150.99253,209.040942 1150.99253,199.346289 L1150.99253,142.390207 C1150.99253,132.695554 1145.54046,127.242312 1135.84789,127.242312 Z",
    id: "Path",
    fill: "#010709",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1284.26536,175.133891 L1284.26536,142.384142 C1284.26536,132.689489 1278.81329,127.236247 1269.12072,127.236247 L1208.54217,127.236247 C1198.8496,127.236247 1193.39753,132.689489 1193.39753,142.384142 L1193.39753,415.046239 C1193.39753,424.740892 1198.8496,430.194134 1208.54217,430.194134 L1269.12072,430.194134 C1278.81329,430.194134 1284.26536,424.740892 1284.26536,415.046239 L1284.26536,287.198011 C1284.26536,238.72475 1316.97778,221.759108 1350.90177,222.970939 C1358.77698,222.970939 1363.01748,218.123613 1363.01748,208.428961 L1363.01748,136.9309 C1363.01748,127.236247 1357.56541,120.571174 1347.26705,122.388921 C1317.17162,126.909057 1293.30368,144.716921 1284.26536,175.133891 Z",
    id: "Path",
    fill: "#010709",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1556.26306,122.394986 L1556.26307,122.388921 C1566.56142,120.571174 1572.01349,127.236247 1572.01349,136.9309 L1572.01349,208.428961 C1572.01349,218.123613 1567.77299,222.970939 1559.89778,222.970939 C1525.97379,221.759108 1493.26137,238.72475 1493.26137,287.198011 L1493.26137,415.046239 C1493.26137,424.740892 1487.8093,430.194134 1478.11673,430.194134 L1417.53818,430.194134 C1407.84561,430.194134 1402.39354,424.740892 1402.39354,415.046239 L1402.39354,142.384142 C1402.39354,132.689489 1407.84561,127.236247 1417.53818,127.236247 L1478.11673,127.236247 C1487.8093,127.236247 1493.26137,132.689489 1493.26137,142.384142 L1493.26137,175.133891 C1502.29969,144.716921 1526.16764,126.909057 1556.26306,122.394986 Z",
    id: "Path",
    fill: "#010709",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    fill: "#FAD045",
    cx: 875.360108,
    cy: 45.443683,
    rx: 45.4339156,
    ry: 45.443683
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-2",
    transform: "translate(0.000000, 123.804164)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-138",
    fill: "#000000",
    cx: 48.9007044,
    cy: 48.9007044,
    r: 48.9007044
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-139",
    fill: "#000000",
    cx: 48.9007044,
    cy: 157.568936,
    r: 48.9007044
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-140",
    fill: "#000000",
    cx: 48.9007044,
    cy: 266.237168,
    r: 48.9007044
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-141",
    fill: "#000000",
    cx: 157.568936,
    cy: 48.9007044,
    r: 48.9007044
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-142",
    fill: "#FFE10B",
    cx: 157.568936,
    cy: 157.568936,
    r: 38.0338812
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-143",
    fill: "#FFE10B",
    cx: 157.568936,
    cy: 266.237168,
    r: 38.0338812
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-144",
    fill: "#000000",
    cx: 266.237168,
    cy: 48.9007044,
    r: 48.9007044
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-145",
    fill: "#FFE10B",
    cx: 266.237168,
    cy: 157.568936,
    r: 38.0338812
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-146",
    fill: "#FAD045",
    cx: 266.237168,
    cy: 266.237168,
    r: 27.167058
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-42",
    fill: "#FAD045",
    x: 119.535055,
    y: 119.535055,
    width: 76.0677624,
    height: 195.602818,
    rx: 38.0338812
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.336464,59.7675276 C238.341997,59.7675276 255.370345,76.7958762 255.370345,97.8014088 L255.370345,217.336464 C255.370345,238.341997 238.341997,255.370345 217.336464,255.370345 C196.330931,255.370345 179.302583,238.341997 179.302583,217.336464 L179.302583,97.8014088 C179.302583,76.7958762 196.330931,59.7675276 217.336464,59.7675276 Z",
    id: "Rectangle-Copy-43",
    fill: "#FAD045",
    transform: "translate(217.336464, 157.568936) rotate(-90.000000) translate(-217.336464, -157.568936) "
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLogo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo.8c4a0189.svg";
export { ForwardRef as ReactComponent };